import { path } from 'utils'
import { z } from 'zod'

import { OperationLevelPermission } from '../auth-claims/permissions'
import { defineApi } from '../http'
import { channelsCodec } from './get-notification-history'

export const notificationStatsPathParamsSchema = z.object({
  orgCode: z.string()
})

export const notificationStatsQueryParamsSchema = z.object({
  channels: channelsCodec
})

const responseSchema = z.object({
  total: z.number(),
  unread: z.number(),
  read: z.number()
})

export type NotificationStatsResponse = z.infer<typeof responseSchema>

export const getNotificationStatsApi = defineApi({
  pathSchema: notificationStatsPathParamsSchema,
  querySchema: notificationStatsQueryParamsSchema,
  pathFor: (params) =>
    path(`/notifications/history/${params.orgCode}/stats`, {
      channels: params.channels
    }),
  gatewayPath: '/history/:orgCode/stats' as const,
  name: 'GetNotificationStats',
  description:
    'Get notification statistics (total, read, unread counts) for an organization by channel',
  requiredPermissions: OperationLevelPermission.ViewApplicationData,
  responseSchema
})
